import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { SetorCliente } from '../../comum/modelos/setor-cliente';
import { Paginacao } from '../../comum/modelos/paginacao';
import { SetorService } from '../setor.service';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { SetorPontoFisico } from '../../comum/modelos/setor-ponto-fisico';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
    selector: 'app-listar-setores-cliente',
    templateUrl: './listar-setores-cliente.component.html',
    styleUrls: ['./listar-setores-cliente.component.css']
})
export class ListarSetoresClienteComponent implements OnInit {

    @Output() setorPontoFisicoEvent: EventEmitter<SetorPontoFisico[]>;
    @Input() pontosFisicos: PontoFisico[];

    filtroPesquisaNomeSetor: string;
    setoresCliente: SetorCliente[];
    setoresPontoFisicoSelecionados: SetorPontoFisico[];
    setoresClienteSelecionados: SetorCliente[];
    setoresPontoFisico: SetorPontoFisico[];
    paginacao: Paginacao;
    evento: Evento;
    selecionados: boolean;
    public loading = false;
    public statusCode: number;

    constructor(private _setorService: SetorService,
        private _comumService: ComumService,
        private _cookieService: CookieService,
        private router: Router,
        private _authService: AuthService) {
        this.paginacao = new Paginacao();
        this.setoresPontoFisico = new Array<SetorPontoFisico>();
        this.setoresCliente = new Array<SetorCliente>();
        this.setoresPontoFisicoSelecionados = new Array<SetorPontoFisico>();
        this.setoresClienteSelecionados = new Array<SetorCliente>();
        this.evento = this._comumService.evento;

        this.setorPontoFisicoEvent = new EventEmitter<SetorPontoFisico[]>();

        if (this.evento !== undefined) {
            setTimeout(() => {
                this._comumService.cleanEvent();
            }, 2000);
        }

    }

    ngOnInit() {
        this.paginacao.itens = 5;
        this.paginacao.page = 1;
        this.loading = true;

        const self = this;

        forkJoin(self._setorService.obterSetoresClienteHttp(parseInt(this._cookieService.get('idCliente'))),
                self._setorService.obterSetoresPontosFisicosHttp(self.pontosFisicos))
                .subscribe(([setoresCliente, setoresPontoFisico]) => {
                    self.setoresPontoFisico = setoresPontoFisico;
                    for (const setorCliente of setoresCliente) {
                        for (const setorPontoFisico of setoresPontoFisico) {
                            if (setorPontoFisico.idSetorCliente === setorCliente.idSetorCliente) {
                                setorCliente.selecionado = true;
                                break;
                            }
                        }
                        self.setoresCliente.push(setorCliente);
                    }
                    self.loading = false;
                });
    }

    pesquisarPorFiltro(filtro: any): void {
        this.filtroPesquisaNomeSetor = filtro.value;
    }

    selecionar(setorCliente: SetorCliente): void {
        setorCliente.selecionado = !setorCliente.selecionado;
        if (setorCliente.selecionado) {
            this.setoresClienteSelecionados.push(setorCliente);
        } else {
            const index = this.setoresClienteSelecionados.indexOf(setorCliente);
            this.setoresClienteSelecionados.splice(index, 1);
        }

        setorCliente.alterado = true;
    }

    selecionarTodos(): void {
        this.selecionados = !this.selecionados;
        this.setoresCliente.forEach(setorCliente => {
            setorCliente.selecionado = this.selecionados;
            setorCliente.alterado = true;
        });
    }

    emit(): void {
        const setoresSelecionados: SetorPontoFisico[] = new Array<SetorPontoFisico>();
        for (const setorCliente of this.setoresCliente) {
            if (setorCliente.selecionado) {
                for (const pontoFisico of this.pontosFisicos) {
                    const novoSetorPontoFisico = new SetorPontoFisico();
                    novoSetorPontoFisico.pontoFisico.idPontoFisico = pontoFisico.idPontoFisico;
                    novoSetorPontoFisico.idSetorCliente = setorCliente.idSetorCliente;
                    novoSetorPontoFisico.selecionado = true;
                    novoSetorPontoFisico.alterado = true;
                    for (const setorPontoFisico of this.setoresPontoFisico) {
                        if (setorPontoFisico.pontoFisico.idPontoFisico === pontoFisico.idPontoFisico
                            && setorPontoFisico.idSetorCliente === setorCliente.idSetorCliente) {
                            novoSetorPontoFisico.alterado = false;
                            break;
                        }
                    }
                    if (novoSetorPontoFisico.alterado) {
                        setoresSelecionados.push(novoSetorPontoFisico);
                    }
                }
            } else if (!setorCliente.selecionado && setorCliente.alterado) {
                for (const setorPontoFisico of this.setoresPontoFisico) {
                    if (setorPontoFisico.idSetorCliente === setorCliente.idSetorCliente) {
                        setorPontoFisico.selecionado = false;
                        setorPontoFisico.alterado = true;
                        setoresSelecionados.push(setorPontoFisico);
                    }
                }
            }
        }
        this.setorPontoFisicoEvent.emit(setoresSelecionados);
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/listar-setores-cliente/listar-setores-cliente.component.ts